export default __webpack_public_path__ + "static/Top10_Broker_Group_2025-50ad543ce23b4cb1b41927e7a35a8f7d.png";